export default __webpack_public_path__ + "static/media/check.6be4196d.svg";